import React, {useState, useEffect, useContext} from "react";
import {useTranslation} from "react-i18next";
import {Helmet} from "react-helmet";
import "../../assets/stylesheets/our-space.css";
import Logo from "../../assets/image/logo.svg";
import i18n from 'i18next';
import {ContactInfoContext} from "./ContactInfoContext";

function OurSpace() {
    const {t} = useTranslation(["ourspace"]);
    const [images, setImages] = useState([]);
    const [selectedImage, setSelectedImage] = useState(null);
    const {contactInfo} = useContext(ContactInfoContext);

    useEffect(() => {
        if (contactInfo.ourSpaces && Array.isArray(contactInfo.ourSpaces)) {
            const filtered = contactInfo.ourSpaces.filter(item => typeof item === 'string' && /\.[^./\\]+$/.test(item));
            setImages(filtered);
        }
    }, [contactInfo.ourSpaces]);

    const openModal = (image) => {
        setSelectedImage(image);
        document.body.style.overflow = "hidden";
    };

    const closeModal = () => {
        setSelectedImage(null);
        document.body.style.overflow = "auto";
    };

    return (
        <>
            <Helmet>
                <link rel="canonical" href={`https://sievn.am/${i18n.language}/${t("ourspace-url")}`}/>
                <meta property="og:url" content={`https://sievn.am/${i18n.language}/${t("ourspace-url")}`}/>
                <meta property="og:title" content={t("ourTitle")}/>
                <meta property="og:site_name" content="sievn.am"/>
                <meta property="og:description" content={t("ourDescribe")}/>
                <meta property="og:image" content={Logo}/>
                <meta property="og:image:width" content="1200"/>
                <meta property="og:image:height" content="630"/>
                <meta name="description" content={t("ourDescribe")}/>
                <title>{t("ourTitle")}</title>
            </Helmet>
            <div className="space-page">
                <div className="main-container-space">
                    <div className="headings-space">
                        <h1>
                            <em>{t("ourspace")}</em>
                        </h1>
                    </div>
                    <div className="gallery-space">
                        {images.map((image, index) => (
                            <img
                                key={index}
                                src={image}
                                alt={`Our Space ${index + 1}`}
                                onClick={() => openModal(image)}
                            />
                        ))}
                    </div>
                </div>
            </div>
            {selectedImage && (
                <div className="modal-space active">
                    <div className="modal-content-space">
                        <img src={selectedImage} alt="Expanded View"/>
                        <button className="close-button-space" onClick={closeModal}>
                            &times;
                        </button>
                    </div>
                </div>
            )}
        </>
    );
}

export default OurSpace;